import React, { useEffect, useMemo } from 'react';
import moment from 'moment-mini';

import { useState } from 'react';
import { getJobHistory } from '../../api/client';

import { Box, Card, Divider, Typography, Skeleton, Stack } from '@mui/material';
import { CheckCircle, Warning, Sync } from '@mui/icons-material';
import DeadBonfireIcon from '../../assets/dead-bonfire.svg';

import { getLocalization } from '../../redux/selectors';

const JobsHistoryList = ({ entity }) => {
  const [jobs, setJobs] = useState([]);
  const lookupKey = useMemo(
    () => (entity.entityType === 'source' ? 'tap' : entity.entityType === 'target' ? 'target' : 'id'),
    [entity],
  );
  const [loading, setLoading] = useState(false);
  const localization = getLocalization();

  useEffect(() => {
    const getJobs = async () => {
      try {
        setLoading(true);
        const jobs = await getJobHistory(undefined, entity.tenant_id, entity[lookupKey], entity.entityType);
        setJobs(jobs);
      } finally {
        setLoading(false);
      }
    };
    getJobs()
  }, [entity.tenant_id]);

  if (!jobs || !Array.isArray(jobs)) {
    return null;
  }

  return (
    <Box display="flex" flexDirection="column" width="100%">
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        flex="1"
        maxHeight={'50vh'}
        width="100%"
        overflow="hidden"
        gap={2}
        px={1}
      >
        <Card
          elevation={0}
          sx={{
            display: 'flex',
            alignItems: 'start',
            flexDirection: 'column',
            width: '100%',
            overflowY: 'auto',
          }}
        >
          <Box
            key="title-card"
            display="flex"
            alignItems="flex-start"
            justifyContent="space-between"
            flexDirection="row"
            pb={2}
            style={{ cursor: 'pointer' }}
            position="sticky"
            pt={1}
            gap={1.5}
            backgroundColor="common.white"
            top="0"
          >
            <Typography variant="body2">
              <span style={{ color: '#625E6E' }}>Showing last 5 jobs</span>
            </Typography>
          </Box>
          {loading ? (
            <Stack spacing={1} width="100%">
              {Array.from({ length: 5 }).map((_, index) => (
                <Box key={`skeleton-${index}`} width={1}>
                  <Box display="flex" justifyContent="space-between" alignItems="center" height={40}>
                    <Box display="flex" gap={2} alignItems="center">
                      <Skeleton variant="circular" width={20} height={20} />
                      <Skeleton variant="rectangular" width="160px" height="12px" sx={{ borderRadius: '16px' }} />
                    </Box>
                    <Skeleton variant="rectangular" width="160px" height="12px" sx={{ borderRadius: '16px' }} />
                  </Box>
                  <Divider />
                </Box>
              ))}
            </Stack>
          ) : jobs && jobs.length > 0 ? (
            jobs.map((job, index) => (
              <Box
                key={`job-${index}-${job.job_id}`}
                display="flex"
                justifyContent="space-between"
                sx={{
                  height: 56,
                  px: 0.5,
                  width: '100%',
                  borderBottom: ({ palette }) => `1px solid ${palette.divider}`,
                }}
                alignItems="center"
              >
                <Box display="flex" alignItems="center">
                  {job.status === 'JOB_COMPLETED' ? (
                    <CheckCircle sx={{ fontSize: '14px', color: '#36C53C' }} />
                  ) : job.status.includes('FAILED') ? (
                    <Warning sx={{ fontSize: '14px', color: '#FA5240' }} />
                  ) : (
                    <Sync sx={{ fontSize: '14px', color: '#D3D3D3' }} />
                  )}
                  <Typography style={{ marginLeft: 4 }} variant="body1" fontWeight="300">
                    {job.job_id}
                  </Typography>
                </Box>
                <Typography style={{ marginLeft: 4 }} variant="body2" fontWeight="300" color="text.lightish">
                  {moment(job.start_time).format('MMM Do YYYY, h:mm a')}
                </Typography>
              </Box>
            ))
          ) : (
            <Box
              gap={2}
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              height="360px"
              width={1}
            >
              <Box component="img" src={DeadBonfireIcon} alt="GoogleSheet Icon" width="40px" height="40px" />
              <Typography style={{ marginLeft: 4 }} variant="body1" fontWeight="400">
                {localization?.jobHistory?.noJobsCaption || ' Dead bonfire, No jobs have run yet!'}
              </Typography>
            </Box>
          )}
        </Card>
      </Box>
    </Box>
  );
};

export default JobsHistoryList;
